export const JWT_TOKEN = 'exr_token';
export const REFRESH_TOKEN = 'refresh_token';
export const PROD_ENT = 'prod_ent';
export const SESSION = 'session';
export const REGISTER = 'register';
export const QUEUE = 'queue';
export const OFFLINE_ID = 'offineId';
export const STATE_SLICE = 'state_slice';
export const DEFAULT_PAGE_SIZE = 100; // hide paging for now load it all
export const DEFAULT_TOAST_DELAY = 15000;
export const DEBOUNCE_UPDATE = 1000;
